import { Typography } from '@material-ui/core';
import React from 'react';
import Attribute from '../../../interfaces/attribute';
import ConfirmDialog, {
  IConfirmDialogProps,
} from '../../ConfirmDialog/ConfirmDialog';

type Props = Omit<IConfirmDialogProps, 'title' | 'body'> & {
  attribute: Partial<Attribute>;
};

const EditConfirmDialog = ({ open, onClose, attribute, onSubmit }: Props) => (
  <ConfirmDialog
    title="Edit Attribute"
    body={<Contents {...attribute} />}
    open={open}
    onClose={onClose}
    onSubmit={onSubmit}
  />
);

function Contents(attribute: Partial<Attribute>) {
  return (
    <>
      <Typography variant="body1">
        You are editing{' '}
        {
          <span
            style={{
              fontWeight: 'bold',
            }}
          >
            “{attribute.name}”
          </span>
        }
        , once the changes are submitted you no longer will be able to change:{' '}
        <ul>
          <li>Region/Country</li>
          <li>Training System Access</li>
          <li>Attribute type</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        Would you like to continue and add these changes?
      </Typography>
    </>
  );
}

export default EditConfirmDialog;
